// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"Catalog_majorContainer__1p8kE","imgWrap1":"Catalog_imgWrap1__2VUKE","imgWrap2":"Catalog_imgWrap2__1hp-D"};